<template>
    <div class="custom-card overflow-y-scroll mt-5">
        <h4 class="mb-2">{{ nbBlacklist }} blacklisting</h4>

        <DataTable :paginator="paginator" :value="tableData" :rows="rowsPerPage">
            <Column headerStyle="width: 1rem" />
            <Column field="date" header="Date de traitement">
                <template #body="slotProps">
                    <span>{{ slotProps.data.date }}</span>
                </template>
            </Column>
            <Column field="reason" header="Raison">
                <template #body="slotProps">
                    <span>{{ slotProps.data.reason }}</span>
                </template>
            </Column>
            <Column field="action" header="Action">
                <template #body="slotProps">
                    <Button type="button"
                            icon="pi pi-eye"
                            @click="filterCommentsByReason(slotProps.data.uuid)"
                            size="small"
                            :severity="slotProps.data.reason === 'Whitelist' ? 'success' : 'danger'" />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script lang="ts" setup>
import {ref, defineEmits, PropType} from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import {UserBlacklistReason} from "@/models/blacklisting/UserBlacklistHistorique";

const emit = defineEmits(["filter-comments-by-reason"]);
const filterCommentsByReason = (index: string) => {
    emit("filter-comments-by-reason", index);
};
const props = defineProps({
    data: {
        type: Array as PropType<UserBlacklistReason[]>,
        required: true,
    },
});

const tableData = ref(props.data);
const nbBlacklist = ref(props.data.length);
const paginator = ref(false);
const rowsPerPage = ref(3);
// Column configuration
const columns = ref([
    { field: "date", header: "Date de traitement", width: 150 },
    { field: "reason", header: "Raison", width: 200 },
]);

let isResizing = ref(false);
let startX = ref(0);
let startWidth = ref(0);
let columnIndex = ref(0);

// Function to initialize resizing
const initResize = (e: MouseEvent, index: number) => {
    isResizing.value = true;
    startX.value = e.clientX;
    startWidth.value = columns.value[index].width;
    columnIndex.value = index;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
};

// Function to resize column
const resizeColumn = (e: MouseEvent) => {
    if (isResizing.value) {
        const newWidth = startWidth.value + (e.clientX - startX.value);
        columns.value[columnIndex.value].width = Math.max(newWidth, 50); // Prevent column from becoming too small
    }
};

// Function to stop resizing
const stopResize = () => {
    isResizing.value = false;
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);
};
if (nbBlacklist.value > 3) {
    paginator.value = true;
}

</script>

<style scoped lang="scss">
.custom-card {
    height: 500px;
}
</style>